import Vue from 'vue'
import { Watch, Component } from 'vue-property-decorator'
import { AppModule } from "@/store/modules/app"
import { AssetsModule } from '@/store/modules/asset'
import { ErrorsModule } from '@/store/modules/error'
import { AssetFile, SingleAssetUsage } from '@/store/modules/asset'
import { PaintingByNumbersAssetUsage } from '@/components/products/malennachzahlen/util/paintingByNumbersAssetUsage'
import { PaintingByNumbersModule, PaintingFormat } from '@/store/modules/paintingByNumbers'
import { AssetUsage } from '@/utils/assetUsage'
import { ToolbarDeactivations, ToolbarModule } from '@/store/modules/toolbar'
import { CollageClipper } from '@/components/products/malennachzahlen/util/paintingClipper'

@Component
export default class PaintingByNumbersSingleAssetUpload extends Vue {
    protected unsubscribeDeselect?: () => void 
    protected asset?: AssetFile

    get scale() {
        return 1
    }

    get deletingAsset() {
        return PaintingByNumbersModule.deletingAsset
    }

    data() {
        return {
            asset: undefined
        }
    }

    onCancel() {
        if (this.cancel()) {
            this.$emit('cancel')
        }
    }

    onConfirm() {
        if (this.confirmable && this.confirm()) {
            this.$emit('confirm')
        }
    }

    cancel(): boolean {
        ToolbarModule.SetDeactivated(ToolbarDeactivations.ZoomAndRotation | ToolbarDeactivations.Deletion)
        if (PaintingByNumbersModule.showImagePreview) {
            if (ToolbarModule.error) {
                ToolbarModule.SetToolbarError(false)
            }
            if (ToolbarModule.errorKeys.length > 0) {
                ToolbarModule.UnsetErrorKey("paintingimage")
            }
            if (ErrorsModule.keys.length > 0) {
                ErrorsModule.SetError({ key: "paintingimage" })
            }
            if (Object.keys(PaintingByNumbersModule.persistedAssets).length > 0) {
                let persistedAsset = PaintingByNumbersModule.persistedAssets["paintingimage"]
                if (AssetsModule.validAssets.some(a => a.assetId === persistedAsset.assetId)) {
                    PaintingByNumbersModule.SetRecoverPaintingToggled(!PaintingByNumbersModule.recoverPaintingToggled)
                } else {
                    //cancel after deleting persisted asset
                    PaintingByNumbersModule.ClearPersistedAssetData("paintingimage")
                    PaintingByNumbersModule.ClearAllCollages("paintingimage")
                    PaintingByNumbersModule.UnsetActiveAsset("paintingimage")
                    PaintingByNumbersModule.SetPreviewAssetId('')
                    AssetsModule.Select()
                    this.resetStepTwoToFour()
                }
            } else {
                PaintingByNumbersModule.UnsetActiveAsset("paintingimage")
                AssetsModule.Select()
            }
        }
        return true
    }

    resetStepTwoToFour(){
        AppModule.ResetSteps(true)
        PaintingByNumbersModule.SetPaintingFormat(PaintingFormat.LANDSCAPE)
        PaintingByNumbersModule.SetBoxDesign(1)
        PaintingByNumbersModule.SetBoxDesignCategory(0)
        PaintingByNumbersModule.SetTitle('')
        PaintingByNumbersModule.SetUserInputTitle('')
        PaintingByNumbersModule.SetUserFormat('')
        PaintingByNumbersModule.SetStepsReseted(!PaintingByNumbersModule.stepsReseted)
    }

    confirm(): boolean {
        if (this.asset !== undefined && this.asset.assetId !== undefined && !ToolbarModule.error) {
            let imageClipper: CollageClipper | undefined
            let usage = PaintingByNumbersAssetUsage.commitUsage(this.asset, false)
            if (usage) {
                let width = 0
                let height = 0
                width = PaintingByNumbersModule.imageEditorWidth
                height = PaintingByNumbersModule.imageEditorHeight
                if (PaintingByNumbersModule.format === PaintingFormat.PORTRAIT && PaintingByNumbersModule.showImageUpload) {
                    let persistedAsset = PaintingByNumbersModule.persistedAssets["paintingimage"]
                    if (persistedAsset) {
                        let persistedId = persistedAsset.assetId
                            if (this.asset.assetId !== persistedId) {
                                //resetting steps 2-4; setting format to landscape
                                height = PaintingByNumbersModule.imageEditorWidth
                                width = PaintingByNumbersModule.imageEditorHeight
                            }
                        }
                }
                imageClipper = CollageClipper.getCollageClipper(false, width, height)
                imageClipper.initializeUsage(usage, this.asset.rect)
            }
            return this.doConfirm(this.asset, imageClipper, usage)
        } else {
            if (AppModule.currentStepIndex === 0) {
                return this.doConfirm()
            }
            if (!ToolbarModule.error) {
                return this.doConfirm()
            }
            return false
        }
    }

    goToMenu() {
        if(this.confirmable) {
            this.onConfirm()
        }else {
            this.onCancel()
        }
    }

    doConfirm(asset?: AssetFile, imageClipper?: CollageClipper, usage?: SingleAssetUsage): boolean {
        return false
    }

    get confirmable(): boolean {
        return this.asset !== undefined && !ToolbarModule.error
    }

    onClick(asset: AssetFile) {
        let selectedAsset = AssetsModule.selected
        if (selectedAsset) {
            PaintingByNumbersAssetUsage.captureUsage(selectedAsset)
        }
        if (!asset.selected) {
            PaintingByNumbersAssetUsage.prepareUsage(asset)
            AssetsModule.Select(asset)
        }
        this.asset = asset
        ToolbarModule.SetDeactivated(ToolbarDeactivations.None)
    }

    get validAssets() {
        return AssetsModule.validAssets
    }

    @Watch('validAssets')
    validAssetsChanged(newValidAssets: AssetFile[]) {
        let selectedAsset = AssetsModule.selected
        if (!selectedAsset && PaintingByNumbersModule.showImageUpload && this.deletingAsset) {
            //ignore validAssetsChanged due to deletion of asset
            PaintingByNumbersModule.SetDeletingAsset(false)
            return
        }
        if (!selectedAsset && newValidAssets.length > 0) {
            let asset = newValidAssets[0]
            PaintingByNumbersAssetUsage.prepareUsage(asset)
            AssetsModule.Select(asset)
            this.asset = asset
            ToolbarModule.SetDeactivated(ToolbarDeactivations.None)
        }
    }

    mounted() {
        this.unsubscribeDeselect = this.$store.subscribeAction((a, s) => {
            if (a.type === 'Deselect') {
                let selectedAsset = AssetsModule.selected
                if (selectedAsset) {
                    AssetUsage.captureUsage(selectedAsset)
                    AssetsModule.Select()
                    this.asset = undefined
                    ToolbarModule.SetDeactivated(ToolbarDeactivations.ZoomAndRotation | ToolbarDeactivations.Deletion)
                }
            }
        })
        let asset = AssetUsage.getCommitedAsset()
        if (asset) {
            AssetUsage.prepareUsage(asset)
            AssetsModule.Select(asset)
            this.asset = asset
            ToolbarModule.SetDeactivated(ToolbarDeactivations.None)
        } else {
            ToolbarModule.SetDeactivated(ToolbarDeactivations.ZoomAndRotation | ToolbarDeactivations.Deletion)
        }
    }

    destroyed() {
        if (this.unsubscribeDeselect) {
            this.unsubscribeDeselect()
        }
    }

    activate() {
        if (this.asset) {
            ToolbarModule.SetDeactivated(ToolbarDeactivations.None)
        }
    }
}